module.exports = __webpack_public_path__ + "img/layout_horizontal_icon.ab49a4fe.svg";